module.exports = __webpack_public_path__ + "img/fi-klt-valmennus.93b7b034.png";